import { useQuery } from "@tanstack/react-query";
import { isUiMockMode } from "@/config/features";
import { mockExportJobById } from "@/fixtures/exportJobs";
import { fetchExportJob } from "@/features/exports/api/get";
import { isExportActive } from "@/domain/export/exportStatusUi";
import { exportKeys } from "@/lib/query/keys";
import { StudioApiError } from "@/types/api";

export function useExportJob(jobId: string | undefined) {
  const mock = isUiMockMode();

  return useQuery({
    queryKey: exportKeys.detail(jobId ?? ""),
    queryFn: async () => {
      if (mock) {
        const job = jobId ? mockExportJobById(jobId) : undefined;
        if (!job) {
          throw new StudioApiError("NOT_FOUND", "Export job not found");
        }
        return job;
      }
      return fetchExportJob(jobId!);
    },
    enabled: !!jobId,
    refetchInterval: mock
      ? false
      : (query) => {
          const status = query.state.data?.status;
          return status && isExportActive(status) ? 2500 : false;
        },
  });
}
